import React from "react";

const WarningGreyIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_373_952"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="20"
        height="20"
      >
        <rect y="2" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_373_952)">
        <path
          d="M10.0013 16.167C10.2374 16.167 10.4353 16.0871 10.5951 15.9274C10.7548 15.7677 10.8346 15.5698 10.8346 15.3337V12.0003C10.8346 11.7642 10.7548 11.5663 10.5951 11.4066C10.4353 11.2469 10.2374 11.167 10.0013 11.167C9.76519 11.167 9.56727 11.2469 9.40755 11.4066C9.24783 11.5663 9.16797 11.7642 9.16797 12.0003V15.3337C9.16797 15.5698 9.24783 15.7677 9.40755 15.9274C9.56727 16.0871 9.76519 16.167 10.0013 16.167ZM10.0013 9.50033C10.2374 9.50033 10.4353 9.42046 10.5951 9.26074C10.7548 9.10102 10.8346 8.9031 10.8346 8.66699C10.8346 8.43088 10.7548 8.23296 10.5951 8.07324C10.4353 7.91352 10.2374 7.83366 10.0013 7.83366C9.76519 7.83366 9.56727 7.91352 9.40755 8.07324C9.24783 8.23296 9.16797 8.43088 9.16797 8.66699C9.16797 8.9031 9.24783 9.10102 9.40755 9.26074C9.56727 9.42046 9.76519 9.50033 10.0013 9.50033ZM10.0013 20.3337C8.84852 20.3337 7.76519 20.1149 6.7513 19.6774C5.73741 19.2399 4.85547 18.6462 4.10547 17.8962C3.35547 17.1462 2.76172 16.2642 2.32422 15.2503C1.88672 14.2364 1.66797 13.1531 1.66797 12.0003C1.66797 10.8475 1.88672 9.76421 2.32422 8.75033C2.76172 7.73644 3.35547 6.85449 4.10547 6.10449C4.85547 5.35449 5.73741 4.76074 6.7513 4.32324C7.76519 3.88574 8.84852 3.66699 10.0013 3.66699C11.1541 3.66699 12.2374 3.88574 13.2513 4.32324C14.2652 4.76074 15.1471 5.35449 15.8971 6.10449C16.6471 6.85449 17.2409 7.73644 17.6784 8.75033C18.1159 9.76421 18.3346 10.8475 18.3346 12.0003C18.3346 13.1531 18.1159 14.2364 17.6784 15.2503C17.2409 16.2642 16.6471 17.1462 15.8971 17.8962C15.1471 18.6462 14.2652 19.2399 13.2513 19.6774C12.2374 20.1149 11.1541 20.3337 10.0013 20.3337ZM10.0013 18.667C11.8624 18.667 13.4388 18.0212 14.7305 16.7295C16.0221 15.4378 16.668 13.8614 16.668 12.0003C16.668 10.1392 16.0221 8.56283 14.7305 7.27116C13.4388 5.97949 11.8624 5.33366 10.0013 5.33366C8.14019 5.33366 6.5638 5.97949 5.27214 7.27116C3.98047 8.56283 3.33464 10.1392 3.33464 12.0003C3.33464 13.8614 3.98047 15.4378 5.27214 16.7295C6.5638 18.0212 8.14019 18.667 10.0013 18.667Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default WarningGreyIcon;
